import { Building2, UserPlus } from 'lucide-react'
import { cn } from '@/utils/cn'

interface RocketDealsFormModeToggleProps {
  mode: 'new' | 'existing'
  onModeChange: (mode: 'new' | 'existing') => void
}

export function RocketDealsFormModeToggle({ mode, onModeChange }: RocketDealsFormModeToggleProps) {
  return (
    <div className='flex items-center gap-2 p-1 bg-white/[0.04] rounded-lg border border-white/[0.06] w-fit'>
      <button
        type='button'
        onClick={() => onModeChange('new')}
        className={cn(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold transition-all min-h-[44px]',
          mode === 'new'
            ? 'bg-accent text-white shadow-lg shadow-accent/20'
            : 'text-text-muted hover:text-text-primary',
        )}
      >
        <UserPlus size={13} />
        Novo Lead
      </button>
      <button
        type='button'
        onClick={() => onModeChange('existing')}
        className={cn(
          'flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold transition-all min-h-[44px]',
          mode === 'existing'
            ? 'bg-accent text-white shadow-lg shadow-accent/20'
            : 'text-text-muted hover:text-text-primary',
        )}
      >
        <Building2 size={13} />
        Empresa Existente
      </button>
    </div>
  )
}
